import { render, staticRenderFns } from "./newindex.vue?vue&type=template&id=7f33fa78&scoped=true&"
import script from "./newindex.vue?vue&type=script&lang=js&"
export * from "./newindex.vue?vue&type=script&lang=js&"
import style0 from "./newindex.vue?vue&type=style&index=0&id=7f33fa78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33fa78",
  null
  
)

export default component.exports